export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "estimated_harvests_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosechas"])},
          "estimated_containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "schedule_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programación"])},
          "new_estimated_harvest_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva estimación de cosecha"])},
          "total_number_estimated_harvests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosechas estimadas"])},
          "total_number_estimated_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores estimados"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar estimación de cosecha"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro que desea eliminar esta estimación de cosecha?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}